import { defineRecipe } from '@chakra-ui/react';

/**
 * Selected gold shared by tabs, pill filters, and multi toggles.
 * `tint` is a wash. `solid` is a filled chip. Resting styles stay on the control.
 */
export const toggleRecipe = defineRecipe({
  variants: {
    tone: {
      tint: {},
      solid: {},
    },
    selected: {
      true: {},
      false: {},
    },
  },
  compoundVariants: [
    {
      tone: 'tint',
      selected: true,
      css: {
        bg: 'accent/16',
        color: 'accent',
        borderColor: 'accent',
      },
    },
    {
      tone: 'solid',
      selected: true,
      css: {
        bg: 'accent',
        color: 'bg',
        borderColor: 'accent',
      },
    },
  ],
  defaultVariants: {
    tone: 'tint',
    selected: true,
  },
});
